/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What the event is about: the card itself, one of its assignments, a charging session, a charging station, or a charging cost.
 */
export type CardEventDtoSubject = typeof CardEventDtoSubject[keyof typeof CardEventDtoSubject];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardEventDtoSubject = {
  CARD: 'CARD',
  ASSIGNMENT: 'ASSIGNMENT',
  CHARGING: 'CHARGING',
  STATION: 'STATION',
  COST: 'COST',
} as const;
